export type GradientConfig = {
  id: string
  stops: Array<{
    color: string
    offset: string
  }>
  x1?: string
  y1?: string
  x2?: string
  y2?: string
  gradientUnits?: string
}

export const ICON_GRADIENTS: Record<string, GradientConfig> = {
  navy: {
    id: 'gradient-navy',
    stops: [
      { color: '#233145', offset: '0' },
      { color: '#3B5479', offset: '1' },
    ],
    x1: '2.80589',
    y1: '1.625',
    x2: '27.5509',
    y2: '13.5881',
    gradientUnits: 'userSpaceOnUse',
  },
  'navy-md': {
    id: 'gradient-navy-md',
    stops: [
      { color: 'var(--color-navy-400)', offset: '3.84%' },
      { color: 'var(--color-navy-300)', offset: '103.01%' },
    ],
    x1: '1.86451',
    y1: '0.8125',
    x2: '23.4791',
    y2: '11.2622',
    gradientUnits: 'userSpaceOnUse',
  },
  green: {
    id: 'gradient-green',
    stops: [
      { color: '#037065', offset: '0' },
      { color: '#19A884', offset: '1' },
    ],
    x1: '1.625',
    y1: '2.84559',
    x2: '25.7978',
    y2: '13.0314',
    gradientUnits: 'userSpaceOnUse',
  },
  red: {
    id: 'gradient-red',
    stops: [
      { color: '#991B1B', offset: '0' },
      { color: '#DC2626', offset: '1' },
    ],
    x1: '1.125',
    y1: '2.66029',
    x2: '26.0155',
    y2: '14.176',
    gradientUnits: 'userSpaceOnUse',
  },
  yellow: {
    id: 'gradient-yellow',
    stops: [
      { color: '#FFD11F', offset: '0' },
      { color: '#E3B608', offset: '1' },
    ],
    x1: '0.000244243',
    y1: '1.16176',
    x2: '24.5506',
    y2: '12.5545',
    gradientUnits: 'userSpaceOnUse',
  },
  orange: {
    id: 'gradient-orange',
    stops: [
      { color: 'var(--color-orange-600)', offset: '1.74%' },
      { color: 'var(--color-orange-500)', offset: '98.26%' },
    ],
    x1: '0%',
    y1: '28.79%',
    x2: '100%',
    y2: '71.21%',
    gradientUnits: 'objectBoundingBox',
  },
  alabaster: {
    id: 'gradient-alabaster',
    stops: [
      { color: '#7F8271', offset: '0.427885' },
      { color: '#A0A392', offset: '1' },
    ],
    x1: '5.25',
    y1: '3.39706',
    x2: '22.3169',
    y2: '8.37585',
    gradientUnits: 'userSpaceOnUse',
  },
}
